module.exports = __webpack_public_path__ + "img/p23.e3d8092c.svg";